export const HITLAB_INTAKE_PATH = '/hitlab/intake';
export const HITLAB_SUBMIT_PATH = '/hitlab/submit';

const HITLAB_ATTRIBUTION_KEYS = ['src', 'campaign', 'ref'];

export function isHitLabClientEnabled(
  value = process.env.REACT_APP_HITLAB_ARTIST_INTAKE_ENABLED,
) {
  const normalized = String(value || '').trim().toLowerCase();
  return !['0', 'false', 'off', 'disabled'].includes(normalized);
}

export function getHitLabAttribution(search = '') {
  const params = new URLSearchParams(search || '');
  return HITLAB_ATTRIBUTION_KEYS.reduce((acc, key) => {
    const value = String(params.get(key) || '').trim().slice(0, 80);
    if (value) acc[key] = value;
    return acc;
  }, {});
}

export function buildHitLabIntakeReturnTo(search = '') {
  const attribution = getHitLabAttribution(search);
  const params = new URLSearchParams();
  Object.entries(attribution).forEach(([key, value]) => params.set(key, value));
  const query = params.toString();
  return query ? `${HITLAB_INTAKE_PATH}?${query}` : HITLAB_INTAKE_PATH;
}

export function buildHitLabLoginPath(search = '') {
  return `/login?returnTo=${encodeURIComponent(buildHitLabIntakeReturnTo(search))}`;
}

export function getApiMessage(error, fallback) {
  return error?.response?.data?.message || fallback;
}

export function isHttpsSongUrl(value) {
  const raw = String(value || '').trim();
  if (!raw) return false;
  try {
    return new URL(raw).protocol === 'https:';
  } catch (err) {
    return false;
  }
}
